"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Photo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const mui_page_layout_1 = require("@dzambalaorg/mui-page-layout");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_2 = require("../../../types");
const PHOTOS_URL = {
    [types_2.ServiceType.ADMIN]: "/ecommerce/photos",
    [types_2.ServiceType.OFFICE]: "/photos",
};
const Photo = (props) => {
    const { service } = props;
    const { isLoading, allRows } = (0, react_hooks_1.useFetchQuery)(PHOTOS_URL[service]);
    const { mutateAsync } = (0, react_hooks_1.useMutationQuery)(PHOTOS_URL[service], "PUT", void 0, {
        onTransformUrl: (baseUrl, values) => {
            return `${baseUrl}/${values.photo.id}`;
        },
        onTransformData: baseData => {
            return {
                photoStatus: baseData.newStatus,
            };
        },
    });
    const handleChangeStatus = (photo, newStatus) => () => mutateAsync({ data: { photo, newStatus } });
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, { children: [(0, jsx_runtime_1.jsx)(mui_page_layout_1.Breadcrumbs, { path: ["dashboard", "ecommerce", "photos"] }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.PageHeader, { message: "pages.photos.title" }), (0, jsx_runtime_1.jsx)(mui_page_layout_1.ProgressOverlay, { isLoading: isLoading, children: (0, jsx_runtime_1.jsx)(styled_1.StyledListWrapper, { count: allRows.length, isLoading: isLoading, children: allRows.map(photo => ((0, jsx_runtime_1.jsxs)(styled_1.StyledListItem, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemAvatar, { children: (0, jsx_runtime_1.jsx)(ui_kit_1.Avatar, { alt: photo.title, src: photo.imageUrl }) }), (0, jsx_runtime_1.jsx)(ui_kit_1.List.ItemText, { primary: photo.title }), (0, jsx_runtime_1.jsxs)(styled_1.ListActions, { children: [(0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleChangeStatus(photo, types_1.PhotoStatus.APPROVED), message: "form.buttons.approve", dataTestId: "PhotoAproveButton", icon: icons_material_1.Done }), (0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleChangeStatus(photo, types_1.PhotoStatus.DECLINED), message: "form.buttons.delete", dataTestId: "PhotoRejectButton", icon: icons_material_1.Clear })] })] }, photo.id))) }) })] }));
};
exports.Photo = Photo;
//# sourceMappingURL=index.js.map